// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__ONqbi","contactContainer":"ErrorPage_contactContainer__FE-Ls","contact":"ErrorPage_contact__pbY5r"};